import { z } from 'zod';

/**
 * The account backend's session view (@infinix/server auth/routes.ts SessionView): checked on every read, and in the
 * backends' contract tests. Depends on zod only, so backend tests can import it.
 */

export const BusinessUnit = z.object({ id: z.string(), name: z.string(), productCode: z.string().nullable() });
export type BusinessUnit = z.infer<typeof BusinessUnit>;

export const SessionView = z.object({
  user: z.object({ email: z.string() }),
  /** Null for Nest staff: they belong to no organization. */
  organization: z.object({ id: z.string(), name: z.string() }).nullable(),
  level: z.enum(['org', 'bu', 'platform']),
  /** Core roles from the verified token. */
  roles: z.array(z.string()),
  businessUnits: z.array(BusinessUnit),
  /** Null = "All business units" (organization-level people only). */
  activeBusinessUnitId: z.string().nullable(),
  /** Staff: whether this Nest can show tenant data to staff (Core's staff route set configured). Absent from an older account backend. */
  staffTenantAccess: z.boolean().default(false),
  csrfToken: z.string(),
  idleTimeoutSec: z.number().int().positive(),
  expiresAt: z.number().int(),
});
export type SessionView = z.infer<typeof SessionView>;

